export const en = {
  nav: {
    markets: "Markets",
    portfolio: "Portfolio",
    admin: "Admin",
    about: "About",
    connectWallet: "Connect Wallet",
  },
  markets: {
    title: "Event Contracts",
    subtitle: "Trade on the outcome of real-world events in Greece & Cyprus",
    search: "Search markets...",
    allCategories: "All",
    volume: "Volume",
    endDate: "Settles",
    yes: "Yes",
    no: "No",
    noMarkets: "No markets found",
    trending: "Trending",
    new: "New",
    closing: "Closing Soon",
  },
  detail: {
    resolutionCriteria: "Resolution Criteria",
    sourceOfTruth: "Source of Truth",
    settlement: "Settlement",
    settlementDesc: "This contract settles to $1.00 if the outcome is YES, and $0.00 if NO. Tokens can be redeemed after resolution.",
    timeline: "Timeline",
    created: "Created",
    settles: "Settles",
    trade: "Trade",
    amount: "Amount",
    shares: "Outcome Tokens",
    potentialReturn: "Potential Return",
    avgPrice: "Avg Price",
    placeTrade: "Place Trade",
    back: "Back to Markets",
    volume24h: "24h Volume",
    totalVolume: "Total Volume",
    liquidity: "Liquidity",
  },
  portfolio: {
    title: "Portfolio",
    subtitle: "Your positions and trading activity",
    positions: "Open Positions",
    history: "Trade History",
    noPositions: "No open positions",
    noTrades: "No trade history",
    connectPrompt: "Connect your wallet to view positions",
    totalValue: "Total Value",
    unrealizedPnl: "Unrealized P&L",
    claim: "Claim",
    market: "Market",
    side: "Side",
    tokens: "Tokens",
    avgCost: "Avg Cost",
    currentPrice: "Current Price",
    value: "Value",
    pnl: "P&L",
  },
  admin: {
    title: "Admin Panel",
    subtitle: "Manage event contracts",
    addMarket: "Add Market",
    questionEn: "Question (English)",
    questionGr: "Question (Greek)",
    descriptionEn: "Description (English)",
    descriptionGr: "Description (Greek)",
    category: "Category",
    endDate: "End Date",
    resolutionSource: "Resolution Source",
    save: "Save Market",
    cancel: "Cancel",
    edit: "Edit",
    resolve: "Resolve",
    delete: "Delete",
  },
  about: {
    title: "About Orion Predict",
    subtitle: "Event contract infrastructure for the Eastern Mediterranean",
    methodology: "Methodology",
    methodologyText: "Orion Predict uses a continuous double auction mechanism for price discovery of event contracts. Each contract represents a binary outcome — YES or NO — and settles at $1.00 or $0.00 upon resolution.",
    howItWorks: "How It Works",
    step1Title: "Browse Contracts",
    step1Desc: "Explore event contracts across politics, economics, energy, and more.",
    step2Title: "Trade Positions",
    step2Desc: "Buy YES or NO outcome tokens based on your market view.",
    step3Title: "Settlement",
    step3Desc: "Contracts resolve based on verifiable real-world outcomes.",
    transparency: "Transparency & Sources",
    transparencyText: "All resolution criteria are clearly defined. Sources include official government publications, Eurostat, central bank data, and recognized sporting authorities.",
  },
  footer: {
    disclaimer: "This platform displays experimental event contracts for informational and research purposes. Event contracts are speculative instruments and involve risk of loss. Past performance does not guarantee future results. This platform does not constitute financial advice.",
    rights: "© 2026 Orion Predict. All rights reserved.",
    terms: "Terms",
    privacy: "Privacy",
    docs: "Documentation",
  },
  categories: {
    "cyprus-politics": "Cyprus Politics",
    "cyprus-economy": "Cyprus Economy",
    "cyprus-energy": "Cyprus Energy",
    "cyprus-real-estate": "Cyprus Real Estate",
    "greece-politics": "Greece Politics",
    "greece-economy": "Greece Economy",
    "greece-energy": "Greece Energy",
    "greece-real-estate": "Greece Real Estate",
    "sports-greece": "Sports Greece",
    "sports-cyprus": "Sports Cyprus",
    "crypto": "Crypto",
    "global-markets": "Global Markets",
  },
};

export const gr = {
  nav: {
    markets: "Αγορές",
    portfolio: "Χαρτοφυλάκιο",
    admin: "Διαχείριση",
    about: "Σχετικά",
    connectWallet: "Σύνδεση Πορτοφολιού",
  },
  markets: {
    title: "Συμβόλαια Γεγονότων",
    subtitle: "Διαπραγματευτείτε βάσει αποτελέσματος πραγματικών γεγονότων σε Ελλάδα & Κύπρο",
    search: "Αναζήτηση αγορών...",
    allCategories: "Όλα",
    volume: "Όγκος",
    endDate: "Λήξη",
    yes: "Ναι",
    no: "Όχι",
    noMarkets: "Δεν βρέθηκαν αγορές",
    trending: "Τάσεις",
    new: "Νέα",
    closing: "Κλείνουν Σύντομα",
  },
  detail: {
    resolutionCriteria: "Κριτήρια Επίλυσης",
    sourceOfTruth: "Πηγή Αλήθειας",
    settlement: "Διακανονισμός",
    settlementDesc: "Αυτό το συμβόλαιο διακανονίζεται στα $1.00 αν η έκβαση είναι ΝΑΙ, και $0.00 αν ΟΧΙ. Τα tokens μπορούν να εξαργυρωθούν μετά την επίλυση.",
    timeline: "Χρονοδιάγραμμα",
    created: "Δημιουργήθηκε",
    settles: "Λήξη",
    trade: "Συναλλαγή",
    amount: "Ποσό",
    shares: "Tokens Αποτελέσματος",
    potentialReturn: "Πιθανή Απόδοση",
    avgPrice: "Μέση Τιμή",
    placeTrade: "Εκτέλεση Συναλλαγής",
    back: "Πίσω στις Αγορές",
    volume24h: "Όγκος 24ω",
    totalVolume: "Συνολικός Όγκος",
    liquidity: "Ρευστότητα",
  },
  portfolio: {
    title: "Χαρτοφυλάκιο",
    subtitle: "Οι θέσεις σας και η δραστηριότητα συναλλαγών",
    positions: "Ανοιχτές Θέσεις",
    history: "Ιστορικό Συναλλαγών",
    noPositions: "Δεν υπάρχουν ανοιχτές θέσεις",
    noTrades: "Δεν υπάρχει ιστορικό συναλλαγών",
    connectPrompt: "Συνδέστε το πορτοφόλι σας για να δείτε θέσεις",
    totalValue: "Συνολική Αξία",
    unrealizedPnl: "Μη Πραγματοποιημένο Κ/Ζ",
    claim: "Αξίωση",
    market: "Αγορά",
    side: "Πλευρά",
    tokens: "Tokens",
    avgCost: "Μέσο Κόστος",
    currentPrice: "Τρέχουσα Τιμή",
    value: "Αξία",
    pnl: "Κ/Ζ",
  },
  admin: {
    title: "Πίνακας Διαχείρισης",
    subtitle: "Διαχείριση συμβολαίων γεγονότων",
    addMarket: "Προσθήκη Αγοράς",
    questionEn: "Ερώτηση (Αγγλικά)",
    questionGr: "Ερώτηση (Ελληνικά)",
    descriptionEn: "Περιγραφή (Αγγλικά)",
    descriptionGr: "Περιγραφή (Ελληνικά)",
    category: "Κατηγορία",
    endDate: "Ημερομηνία Λήξης",
    resolutionSource: "Πηγή Επίλυσης",
    save: "Αποθήκευση",
    cancel: "Ακύρωση",
    edit: "Επεξεργασία",
    resolve: "Επίλυση",
    delete: "Διαγραφή",
  },
  about: {
    title: "Σχετικά με το Orion Predict",
    subtitle: "Υποδομή συμβολαίων γεγονότων για την Ανατολική Μεσόγειο",
    methodology: "Μεθοδολογία",
    methodologyText: "Το Orion Predict χρησιμοποιεί μηχανισμό συνεχούς διπλής δημοπρασίας για τον καθορισμό τιμών συμβολαίων γεγονότων. Κάθε συμβόλαιο αντιπροσωπεύει δυαδική έκβαση — ΝΑΙ ή ΟΧΙ — και διακανονίζεται στα $1.00 ή $0.00 κατά την επίλυση.",
    howItWorks: "Πώς Λειτουργεί",
    step1Title: "Εξερευνήστε Συμβόλαια",
    step1Desc: "Ανακαλύψτε συμβόλαια γεγονότων σε πολιτική, οικονομία, ενέργεια και άλλα.",
    step2Title: "Συναλλαγές Θέσεων",
    step2Desc: "Αγοράστε YES ή NO tokens αποτελέσματος βάσει της άποψής σας.",
    step3Title: "Διακανονισμός",
    step3Desc: "Τα συμβόλαια επιλύονται βάσει επαληθεύσιμων πραγματικών αποτελεσμάτων.",
    transparency: "Διαφάνεια & Πηγές",
    transparencyText: "Όλα τα κριτήρια επίλυσης ορίζονται σαφώς. Οι πηγές περιλαμβάνουν επίσημες κυβερνητικές δημοσιεύσεις, Eurostat, δεδομένα κεντρικών τραπεζών και αναγνωρισμένες αθλητικές αρχές.",
  },
  footer: {
    disclaimer: "Αυτή η πλατφόρμα εμφανίζει πειραματικά συμβόλαια γεγονότων για ενημερωτικούς και ερευνητικούς σκοπούς. Τα συμβόλαια γεγονότων είναι κερδοσκοπικά μέσα και ενέχουν κίνδυνο απώλειας. Η προηγούμενη απόδοση δεν εγγυάται μελλοντικά αποτελέσματα. Η πλατφόρμα δεν αποτελεί οικονομική συμβουλή.",
    rights: "© 2026 Orion Predict. Με επιφύλαξη παντός δικαιώματος.",
    terms: "Όροι",
    privacy: "Απόρρητο",
    docs: "Τεκμηρίωση",
  },
  categories: {
    "cyprus-politics": "Πολιτική Κύπρου",
    "cyprus-economy": "Οικονομία Κύπρου",
    "cyprus-energy": "Ενέργεια Κύπρου",
    "cyprus-real-estate": "Ακίνητα Κύπρου",
    "greece-politics": "Πολιτική Ελλάδας",
    "greece-economy": "Οικονομία Ελλάδας",
    "greece-energy": "Ενέργεια Ελλάδας",
    "greece-real-estate": "Ακίνητα Ελλάδας",
    "sports-greece": "Αθλητικά Ελλάδας",
    "sports-cyprus": "Αθλητικά Κύπρου",
    "crypto": "Κρυπτονομίσματα",
    "global-markets": "Παγκόσμιες Αγορές",
  },
};
